webpackJsonp([224195665651807],{

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(103);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      email: '',
	      password: '',
	      newPassword: ''
	    };
	    _this._onSubmit = _this._onSubmit.bind(_this);
	    _this._onSubmitNewPassword = _this._onSubmitNewPassword.bind(_this);
	    _this._onChange = _this._onChange.bind(_this);
	    return _this;
	  }
	
	  Login.prototype._onSubmit = function _onSubmit(event) {
	    event.preventDefault();
	    this.props.login(this.state);
	  };
	
	  Login.prototype._onSubmitNewPassword = function _onSubmitNewPassword(event) {
	    event.preventDefault();
	    var user = this.props.user;
	
	
	    this.props.newPassword(_extends({ user: user }, this.state));
	  };
	
	  Login.prototype._onChange = function _onChange(field, event) {
	    var _setState;
	
	    this.setState((_setState = {}, _setState[field] = event.target.value, _setState));
	  };
	
	  Login.prototype.render = function render() {
	    var _this2 = this;
	
	    var site = (0, _get2.default)(this, 'props.data.site.siteMetadata');
	    var _props = this.props,
	        user = _props.user,
	        userChallenge = _props.userChallenge,
	        loginError = _props.loginError;
	
	    var onChange = function onChange(field) {
	      return function (event) {
	        return _this2._onChange(field, event);
	      };
	    };
	
	    if (user !== null) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'lead' },
	            'Du \xE4r inloggad som ',
	            user.username,
	            '.'
	          )
	        )
	      );
	    }
	
	    if (userChallenge === 'NEW_PASSWORD_REQUIRED') {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'container mb-4' },
	              _react2.default.createElement(
	                'p',
	                { className: 'lead' },
	                'Inloggning till interninfo.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(
	                'form',
	                { onSubmit: this._onSubmitNewPassword },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'form-group col-md-6' },
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'inputNewPassword' },
	                      'Nytt l\xF6senord'
	                    ),
	                    _react2.default.createElement('input', {
	                      onChange: onChange('newPassword'),
	                      type: 'password',
	                      className: 'form-control',
	                      id: 'inputNewPassword',
	                      placeholder: 'Nytt l\xF6senord'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn btn-primary mr-2' },
	                  'Spara nytt l\xF6senord'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    var error = loginError ? _react2.default.createElement(
	      'div',
	      { className: 'alert alert-danger mt-2', role: 'alert' },
	      loginError
	    ) : [];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'section',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'container mb-4' },
	            _react2.default.createElement(
	              'p',
	              { className: 'lead' },
	              'Inloggning till interninfo.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this._onSubmit },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'inputEmail4' },
	                    'Epost'
	                  ),
	                  _react2.default.createElement('input', {
	                    onChange: onChange('email')
	                    //type="email"
	                    , className: 'form-control',
	                    id: 'inputEmail4',
	                    placeholder: 'Epost'
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-group col-md-6' },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'inputPassword4' },
	                    'L\xF6senord'
	                  ),
	                  _react2.default.createElement('input', {
	                    onChange: onChange('password'),
	                    type: 'password',
	                    className: 'form-control',
	                    id: 'inputPassword4',
	                    placeholder: 'L\xF6senord'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary mr-2' },
	                'Logga in'
	              ),
	              error,
	              _react2.default.createElement(
	                'div',
	                { className: 'alert alert-light mt-2', role: 'alert' },
	                '\xC4r du boende och vill ha inloggning? Kontakta ...'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Login;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return state;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    login: function login(data) {
	      return dispatch(_extends({ type: 'LOGIN_REQUESTED' }, data));
	    },
	    newPassword: function newPassword(data) {
	      return dispatch(_extends({ type: 'NEW_PASSWORD' }, data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-inloggning-js-f160e795a1227368c5d8.js